import ukraineFlag from '../images/ukraine/map-1020206_1920.jpg';
import './SupportUkraine.css';
export const SupportUkraine = () => {
	return (
		<div className='panel'>
			<h2>Ukraine fights to protect our western values</h2>
			<h2>Ukraine fights for freedom and justice</h2>
			<div>
				<img className='ukraine-img' src={ukraineFlag} alt='Flag of ukraine' />
			</div>
			<div>
				<h3>Consider giving your support</h3>

				<a href='https://war.ukraine.ua/support-ukraine/'>
					Official site to support Ukraine
				</a>
			</div>
		</div>
	);
};
